/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(4)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(17), __esModule: true };

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(22);
var defined = __webpack_require__(6);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  // require('../../scss/main.scss');
  __webpack_require__(12);

  var FormTabsEngine = __webpack_require__(14);
  var hpFormsOptions = __webpack_require__(16)();
  var PreparePostInit = __webpack_require__(43);

  hpFormsOptions = PreparePostInit(hpFormsOptions, []);

  var hpForms = new FormTabsEngine({

    'form-1': ['airticketForm', hpFormsOptions.letenky],
    'form-2': ['ybusForm', hpFormsOptions.jizdenky]
  });

  // otevirame form airticket, pokud na nej prichaime ze substranek (je poslane url #form-2)
  if (window.location.href.split('#')[1] == 'form-2') {

    // fix na IE, kde se stranka odskrolovala dolu
    var timer = setInterval(function () {

      if ($(window).scrollTop() > 0) {
        $(window).scrollTop(0);
        clearInterval(timer);
      }
    }, 10);

    hpForms.init('form-2');
    $('.tabs').tabs('option', 'active', 1); // toto nam odkryje tab, ktery chceme (jQuery UI Tabs)
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  } else {
    hpForms.init('form-1');
  }

  // incializace formulare letenek pri kliknuti na tlacitko v menu
  $('.footer-menu ul li:last-child a').click(function (e) {
    e.preventDefault();
    window.initAirTicket();
  });

  window.initAirTicket = function (top) {
    hpForms.init('form-2');
    $('.tabs').tabs('option', 'active', 1); // toto nam odkryje tab, ktery chceme (jQuery UI Tabs)
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  };

  $('.hp-special-offers #letenky .content').airticketOffersWidget({
    component_id: 'studentagency.en',
    count: 10,
    random: 5
  });

  // homepage banner slider
  $('.infinite-carousel').infiniteCarousel();

  // hover state na iframz, protoze IE neumi hover na iframe v CSS
  window.iframeHoverState();
})();

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* Author: Student Agency edited by Diego La Monica http://diegolamonica.info
* Detailed description of this work is available on http://diegolamonica.info/improving-jquery-infinite-carousel-part-1
* Based on original script described on http://jqueryfordesigners.com/demo/infinite-carousel.html
*/
(function ($) {
  'use strict';

  $.fn.infiniteCarousel = InfiniteCarousel;
  function InfiniteCarousel() {

    var win = $(window),
        ontouch = __webpack_require__(13),
        wrapper = $('> .slider-wrapper', this).css('overflow', 'hidden'),
        slider = wrapper.find('> ul'),
        items = slider.find('> li'),
        singleWidth = items.filter(':first').outerWidth(true),
        currentPage = 1,
        delay = 8000,
        autoplay = 0;

    initialize();
    win.resize(initialize);

    // buttons
    $('.back', this).click(goBack);
    $('.forward', this).click(goForward);

    // keyboard
    $(document).keydown(function (e) {
      if (e.keyCode === 37) goBack();else if (e.keyCode === 39) goForward();
    });

    // touch
    /*
    zakomentovano, jinak nefunguje posouvani slideru na telefonu
    ontouch(this[0], function(evt, dir, phase){
      if (phase === 'end' && dir === 'left') goForward();
      if (phase === 'end' && dir === 'right') goBack();
    });
    */

    function initialize() {
      stopPlay();
      $('.cloned', wrapper).remove();
      var items = getItems(),
          sliderLeftOffset = (win.width() - $('.wrapper').width()) / 2;
      items.filter(':first').before(clone(items.slice(-3))); // nastavime 3 kvuli mobilu, jinka je videt bile misto kdyz nejsou naklonovane 3 itemy
      items.filter(':last').after(clone(items.slice(0, 3))); // nastavime 3 kvuli mobilu, jinka je videt bile misto kdyz nejsou naklonovane 3 itemy
      //items.filter(':first').before(clone(items.slice(-getPageSize())));
      //items.filter(':last').after(clone(items.slice(0, getPageSize())));
      //wrapper.scrollLeft(singleWidth * getPageSize());
      wrapper.scrollLeft(singleWidth * 3);
      slider.css({
        left: sliderLeftOffset,
        width: getItems().length * singleWidth + singleWidth * 3
      });
      //createPageNav();
      autoPlay();
    }

    function clone(items) {
      items = items.clone().addClass('cloned');
      items.find('iframe').attr('id', '');
      return items;
    }

    function goToPage(page) {

      var direction = page < currentPage ? -1 : 1,
          pageSize = getPageSize(),
          step = Math.abs(currentPage - page),
          scrollLeft = direction * singleWidth * pageSize * step;

      stopPlay();
      wrapper.filter(':not(:animated)').animate({
        scrollLeft: '+=' + scrollLeft
      }, 500).promise().done(animationComplete);
      autoPlay();

      function animationComplete() {
        //console.log('hooked');
        if (page === 0) {
          var correction = void 0;
          if (pageSize === 1) correction = singleWidth * 2;else if (pageSize === 2) correction = singleWidth;else correction = 0;

          wrapper.scrollLeft(singleWidth * pageSize * getPageCount() + correction);
          //wrapper.scrollLeft(singleWidth * pageSize * getPageCount());
          //wrapper.scrollLeft(singleWidth * 3 * getPageCount());
          page = getPageCount();
        } else if (page > getPageCount()) {
          //wrapper.scrollLeft(singleWidth * getPageSize());
          wrapper.scrollLeft(singleWidth * 3);
          page = 1;
        }
        currentPage = page;
        setActivePage(currentPage);
        //console.log(currentPage);
      }
    }

    function createPageNav() {
      var pageNav = $('#pager'),
          i = 0;
      pageNav.empty();
      for (i; i < getPageCount(); i++) {
        $('<span class="pager"/>').click(pagerClickHandler).attr('data-page', i + 1).appendTo(pageNav);
      }

      function pagerClickHandler() {
        /* jshint validthis: true */
        return goToPage($(this).attr('data-page'));
      }
    }

    function setActivePage(page) {
      $('.pager').removeClass('activePage');
      $('.pager[data-page=' + page + ']').addClass('activePage');
    }

    function getItems() {
      return slider.find('> li');
    }

    function getPageSize() {
      var currentPageSie = Math.floor($('.wrapper').width() / singleWidth);
      if (currentPageSie == 0) return 1;else return currentPageSie;
    }

    function getPageCount() {
      return Math.ceil(getItems().not('.cloned').length / getPageSize());
    }

    function autoPlay() {
      autoplay = setInterval(function () {
        goToPage(currentPage + 1);
      }, delay);
    }

    function stopPlay() {
      clearInterval(autoplay);
    }

    function goBack() {
      return goToPage(currentPage - 1);
    }

    function goForward() {
      return goToPage(currentPage + 1);
    }
  }
})(jQuery);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  function ontouch(el, callback) {

    var touchsurface = el,
        dir,
        swipeType,
        startX,
        startY,
        distX,
        distY,
        threshold = 150,
        //required min distance traveled to be considered swipe
    restraint = 100,
        // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 500,
        // maximum time allowed to travel that distance
    elapsedTime,
        startTime,
        handletouch = callback || function (evt, dir, phase, swipetype, distance) {};

    touchsurface.addEventListener('touchstart', function (e) {
      var touchobj = e.changedTouches[0];
      dir = 'none';
      swipeType = 'none';
      dist = 0;
      startX = touchobj.pageX;
      startY = touchobj.pageY;
      startTime = new Date().getTime(); // record time when finger first makes contact with surface
      handletouch(e, 'none', 'start', swipeType, 0); // fire callback function with params dir="none", phase="start", swipetype="none" etc
      e.preventDefault();
    }, false);

    touchsurface.addEventListener('touchmove', function (e) {
      var touchobj = e.changedTouches[0];
      distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
      distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface

      if (Math.abs(distX) > Math.abs(distY)) {
        // if distance traveled horizontally is greater than vertically, consider this a horizontal movement
        dir = distX < 0 ? 'left' : 'right';
        handletouch(e, dir, 'move', swipeType, distX); // fire callback function with params dir="left|right", phase="move", swipetype="none" etc
      } else {
        // else consider this a vertical movement
        dir = distY < 0 ? 'up' : 'down';
        handletouch(e, dir, 'move', swipeType, distY); // fire callback function with params dir="up|down", phase="move", swipetype="none" etc
      }

      e.preventDefault(); // prevent scrolling when inside DIV
    }, false);

    touchsurface.addEventListener('touchend', function (e) {
      var touchobj = e.changedTouches[0];
      elapsedTime = new Date().getTime() - startTime; // get time elapsed

      if (elapsedTime <= allowedTime) // first condition for awipe met
        if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) // 2nd condition for horizontal swipe met
          swipeType = dir; // set swipeType to either "left" or "right"
        else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) // 2nd condition for vertical swipe met
            swipeType = dir; // set swipeType to either "top" or "down"

      // Fire callback function with params dir="left|right|up|down", phase="end", swipetype=dir etc:
      handletouch(e, dir, 'end', swipeType, dir === 'left' || dir === 'right' ? distX : distY);
      e.preventDefault();
    }, false);
  }

  return ontouch;
}();

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(15);

module.exports = function FormTabsEngine(config) {

  if (!$.isPlainObject(config)) return new Error('Parametr config musí být objekt');

  var loadedForms = [];
  var forms = {};
  var formTabsButton = $('.nav-tabs li');

  this.init = loadFormIntoTab;

  formTabsButton.click(handleTabClick);

  for (var key in config) {

    var value = config[key];
    var elemId = '#' + key;

    if (typeof value === 'string') forms[key] = helpers.prepareHtmlLoad(elemId, value);

    if ($.isArray(value) && $.isFunction($(elemId)[value[0]])) forms[key] = helpers.prepareWidget(elemId, value[0], value[1] || {});
  }

  // stejna vyska pro vsechny widgety na hp
  var firstRow = $('.special-offers .box').not('.second-row').find('.content');
  window.countSameHeight(firstRow);
  $(window).resize(function () {
    window.countSameHeight(firstRow);
  });

  function handleTabClick() {

    var formId = $(this).attr('aria-controls');

    loadFormIntoTab(formId);
  }

  function loadFormIntoTab(formId) {

    if (loadedForms.indexOf(formId) < 0 && $.isFunction(forms[formId])) forms[formId]();

    loadedForms.push(formId);
  }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  prepareHtmlLoad: function prepareHtmlLoad(elemId, url) {
    return function () {
      $.get(url, function (data) {
        return $(elemId).html(data);
      });
    };
  },
  prepareWidget: function prepareWidget(elemId, widget, options) {
    return function () {
      $(elemId)[widget](options);
    };
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(5);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function () {

  var theClass = 'form-headline-mobile hidden-desktop';
  var sharedOptions = {
    id: 'studentagency.en',
    hostname: '//olymp9.sa.cz/shared/'

  };
  var options = {
    letenky: {
      formType: 'round_trip',
      header: {
        text: 'Flight tickets',
        className: theClass
      }
    },
    jizdenky: {
      header: {
        text: 'Bus/Train tickets',
        className: theClass
      }
    }
  };

  (0, _keys2.default)(options).forEach(function (key) {
    options[key] = $.extend({}, sharedOptions, options[key]);
  });

  return options;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(18);
module.exports = __webpack_require__(0).Object.keys;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(19);
var $keys = __webpack_require__(20);

__webpack_require__(32)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(6);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(21);
var enumBugKeys = __webpack_require__(31);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(7);
var toIObject = __webpack_require__(8);
var arrayIndexOf = __webpack_require__(24)(false);
var IE_PROTO = __webpack_require__(27)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(23);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(8);
var toLength = __webpack_require__(25);
var toAbsoluteIndex = __webpack_require__(26);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(9);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(9);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(28)('keys');
var uid = __webpack_require__(30);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var global = __webpack_require__(1);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(29) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(33);
var core = __webpack_require__(0);
var fails = __webpack_require__(4);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var core = __webpack_require__(0);
var ctx = __webpack_require__(34);
var hide = __webpack_require__(36);
var has = __webpack_require__(7);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(35);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(37);
var createDesc = __webpack_require__(42);
module.exports = __webpack_require__(3) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(38);
var IE8_DOM_DEFINE = __webpack_require__(39);
var toPrimitive = __webpack_require__(41);
var dP = Object.defineProperty;

exports.f = __webpack_require__(3) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(2);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(3) && !__webpack_require__(4)(function () {
  return Object.defineProperty(__webpack_require__(40)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(2);
var document = __webpack_require__(1).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(2);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(5);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function preparePostInitFunction(options, instead) {

  function sharedFunction(component, context) {
    context.find('select').each(function () {
      //Označovanie vybraného prvku v selectu robilo problémy
      //Vyberiem hodnotu označeného optionu (s atribútom selected)
      var selectedValue = $(this).find('option[selected="selected"]').val();
      var sel = new Select({
        el: this,
        alignToHighlighted: 'always'
      });
      //Zmením hodnotu nového selectu podľa predtým uloženej
      if (selectedValue) sel.change(selectedValue);
    });

    //Natvrdo intervalu označím prvý option. Označoval sa tretí
    var int_option = $('#search_interval option[selected="selected"]');
    if (int_option) int_option.attr("selected", true);
  }

  // postInitHook funkce pro letenky
  function letenky(component, context) {
    var opts = context.data('opts');

    //sharedFunction(context);
    sharedFunction(component, context);

    window.airSelectPostRenderFunction = function () {
      sharedFunction(null, $('#airticket-airline-block'));
    };

    var visible = context.find('#visible-part');
    var hidden = context.find('#hidden-part');

    var showMore = '<i class="sa-icon icon-sipka-dolu"></i>' + opts.messages.showMore;
    var showLess = '<i class="sa-icon icon-sipka-dolu up"></i>' + opts.messages.showLess;

    var toggleDiv = $('<div/>', { 'class': 'toggle-form' });
    var toggleButton = $('<a>' + showMore + '</a>').appendTo(toggleDiv);

    toggleButton.click(toggleForm);

    toggleDiv.insertBefore(hidden);

    function toggleForm() {
      var hiddenPartIsVisible = hidden.is(':visible');
      var button = context.find('.toggle-form a');

      if (hiddenPartIsVisible) {
        hidden.hide('fast');
        button.html(showMore);
      } else {
        hidden.show('fast');
        button.html(showLess);
      }
    }

    function getIntervalSelect() {
      var instance = null;
      $('#form-1').find('select#search_interval').each(function () {
        instance = this.selectInstance;
      });
      return instance;
    }

    //WEB-3369 defaultné hodnoty intervalu
    window.airticketActivateFormCustom = {
      oneway: function oneway() {
        var instance = getIntervalSelect();
        if (instance) instance.change(String($('#oneway').data('search_interval')));
      },
      round_trip: function round_trip() {
        var instance = getIntervalSelect();
        if (instance) instance.change(String($('#round_trip').data('search_interval')));
      },
      open_jaw: function open_jaw() {
        var instance = getIntervalSelect();
        if (instance) instance.change(String($('#open_jaw').data('search_interval')));
      }
    };
  }

  // sestaveni objektu s postInitFunkci
  var postInit = {
    letenky: {
      postInitHook: letenky
    },
    jizdenky: {
      postInitHook: sharedFunction
    }
  };

  (0, _keys2.default)(options).forEach(function (key) {
    if (instead.length !== 0) {
      if (jQuery.inArray(key, instead) !== 0) options[key] = $.extend({}, options[key], postInit[key]);
    } else {
      options[key] = $.extend({}, options[key], postInit[key]);
    }
  });

  return options;
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// homepage.js